import { call, put, takeLatest, select } from 'redux-saga/effects';
import _ from 'lodash';
import { orgId, Ajax } from 'utils';
import * as actionTypes from '../actions/actionTypes';
import * as notificationCenterActions from '../actions/notificationCenterActions';
import * as selectors from '../selectors/notificationCenterSelectors';

export function* getNotificationList({ payload: { firstRender } = {} } = {}) {
  try {
    const baseTime = yield select(selectors.selectDataNotificationListBaseTime);
    const notificationList = yield select(selectors.selectDataNotificationList);
    const url = `/rest/notif?orgId=${orgId}&baseTime=${baseTime}`;
    if (firstRender && baseTime) {
      yield put(notificationCenterActions.getNotificationList.success());
    } else {
      const { data: { pageSize, notificationList: newList } } = yield call(Ajax.get, url);
      yield put(
        notificationCenterActions.getNotificationList.success({
          notificationListPageSize: pageSize,
          notificationListBaseTime: _.get(_.last(newList), 'sendDate', baseTime),
          notificationList: [...notificationList, ...newList],
        }),
      );
    }
  } catch (error) {
    yield put(notificationCenterActions.getNotificationList.fail(error));
  }
}
export function* watchGetNotificationList() {
  yield takeLatest(actionTypes.GET_NOTIFICATION_LIST.ACTION, getNotificationList);
}

export function* getNotification({ payload: { id } } = {}) {
  try {
    const notificationCache = yield select(selectors.selectDataNotificationCache);
    if (!notificationCache[id]) {
      const url = `/rest/notif/${id}?orgId=${orgId}`;
      const { data: { result: notification }, status } = yield call(Ajax.get, url);
      if (status === 200) {
        notificationCache[id] = { ...notification, id };
        yield put(
          notificationCenterActions.getNotification.success({
            notification: notificationCache[id],
          }),
        );
      } else {
        yield put(
          notificationCenterActions.getNotification.success({
            notification: { responseCode: status },
          }),
        );
      }
    } else {
      yield put(
        notificationCenterActions.getNotification.success({
          notification: notificationCache[id],
        }),
      );
    }
  } catch (error) {
    yield put(notificationCenterActions.getNotification.fail(error));
  }
}
export function* watchGetNotification() {
  yield takeLatest(actionTypes.GET_NOTIFICATION.ACTION, getNotification);
}

export function* getWeatherAlertList({ payload: { firstRender } = {} } = {}) {
  try {
    const baseTime = yield select(selectors.selectDataWeatherAlertListBaseTime);
    const weatherAlertList = yield select(selectors.selectDataWeatherAlertList);
    const url = `/rest/weather?orgId=${orgId}&baseTime=${baseTime}`;
    if (firstRender && baseTime) {
      yield put(notificationCenterActions.getWeatherAlertList.success());
    } else {
      const { data: { pageSize, weatherList: newList } } = yield call(Ajax.get, url);
      yield put(
        notificationCenterActions.getWeatherAlertList.success({
          weatherAlertListPageSize: pageSize,
          weatherAlertListBaseTime: _.get(_.last(newList), 'createTime', baseTime),
          weatherAlertList: [...weatherAlertList, ...newList],
        }),
      );
    }
  } catch (error) {
    yield put(notificationCenterActions.getWeatherAlertList.fail(error));
  }
}
export function* watchGetWeatherAlertList() {
  yield takeLatest(actionTypes.GET_WEATHER_ALERT_LIST.ACTION, getWeatherAlertList);
}

export function* getWeatherAlert({ payload: { id } } = {}) {
  try {
    const weatherAlertCache = yield select(selectors.selectDataWeatherAlertCache);
    if (!weatherAlertCache[id]) {
      const url = `/rest/weather/${id}?orgId=${orgId}`;
      const { data: { result: weatherAlert }, status } = yield call(Ajax.get, url);
      if (status === 200) {
        weatherAlertCache[id] = { ...weatherAlert, id };
        yield put(
          notificationCenterActions.getWeatherAlert.success({
            weatherAlert: weatherAlertCache[id],
          }),
        );
      } else {
        yield put(
          notificationCenterActions.getWeatherAlert.success({
            weatherAlert: { responseCode: status },
          }),
        );
      }
    } else {
      yield put(
        notificationCenterActions.getWeatherAlert.success({
          weatherAlert: weatherAlertCache[id],
        }),
      );
    }
  } catch (error) {
    yield put(notificationCenterActions.getWeatherAlert.fail(error));
  }
}
export function* watchGetWeatherAlert() {
  yield takeLatest(actionTypes.GET_WEATHER_ALERT.ACTION, getWeatherAlert);
}
